module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#album",
      toString: function () {
        return this.url;
      }
    }